import englishMessages from './en.json';
import frenchMessages from './fr.json';
import spanishMessages from './es.json';
import japaneseMessages from './ja.json';
import chineseMessages from './zh.json';

const messagesByLanguage = {
  en: englishMessages,
  fr: frenchMessages,
  es: spanishMessages,
  ja: japaneseMessages,
  zh: chineseMessages,
};

export const getMessagesForLanguage = (language, hostedMessages = {}) => {
  const selectedMessages = messagesByLanguage[language] || {};

  return language === 'en'
    ? { ...englishMessages, ...hostedMessages }
    : { ...englishMessages, ...hostedMessages, ...selectedMessages };
};

export default messagesByLanguage;
